import { useTranslation } from 'react-i18next';
import { WifiOff } from 'lucide-react';
import { useIsOnline } from '@/hooks/useIsOnline';

export function OfflineBanner() {
  const online = useIsOnline();
  const { t } = useTranslation();
  if (online) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      className="sticky top-0 z-40 flex items-center justify-center gap-2 bg-warn/20 px-4 py-1.5 text-xs text-parchment-ink"
    >
      <WifiOff className="h-3.5 w-3.5" />
      <span>{t('app.offline')}</span>
    </div>
  );
}
